import { render, staticRenderFns } from "./collectionList.vue?vue&type=template&id=58ec2a52"
import script from "./collectionList.vue?vue&type=script&lang=js"
export * from "./collectionList.vue?vue&type=script&lang=js"
import style0 from "./collectionList.vue?vue&type=style&index=0&id=58ec2a52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports